import { ADD_EMPLOYEE,FAILD_MESSAGE_ADD_EMPLYEE } from "./type";
import * as actionFunction from "./common";


function insertEmployee(post) {
    //console.log("postss" , post.employee_id)
    let fd = new FormData();
    var commonStateData = actionFunction.commonData()
    //console.log("data", commonStateData);
    fd.append('image[]', post.image);
    fd.append('pan_image[]', post.pan_image);
    fd.append('adhar_iamgage[]', post.adhar_iamgage);
    fd.append('employee_id', post.employee_id);
    fd.append('employee_inputs', JSON.stringify(post.Employee));
    return (dispatch) => {
        fetch(commonStateData.apiUrl + '/employee/insert/userAuthKey/' + commonStateData.userAuthKey + '/userId/' + commonStateData.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findResponse) => {
//                findResponse = actionFunction.decrypt(findResponse, 1);
                console.log("new respose from actions", findResponse)
                if (findResponse.code == 200) {
                    if (findResponse.id) {
                        window.location.href = '/viewEmployee/' + findResponse.id;
                    } else {
                        window.location.href = '/employees/';
                    }
                }
                else if (findResponse.code == 500) {
                dispatch({
                        type: FAILD_MESSAGE_ADD_EMPLYEE,
                        registred_member:findResponse.msgpsg,
                        registered_emp_id: findResponse.empidmsg,
                        registered_mail: findResponse.msg,
                        submit_sucsess:1
                })
                }

            })
    }
}

export { insertEmployee };


// WEBPACK FOOTER //
// ./src/actions/addEmployeeAction.js